import { motion } from "framer-motion";

export default function VideoSection() {
  return (
    <section id="video" className="py-20 lg:py-28 bg-white" data-testid="video-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="text-center mb-10"
        >
          <div className="font-tech text-[11px] tracking-[0.3em] text-[#f97316] uppercase mb-4" data-testid="video-kicker">
            In the field
          </div>
          <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl text-[#17150f]" data-testid="video-headline">
            See NOXWAY in action
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="rounded-2xl border border-stone-200 bg-white p-3 shadow-lg"
          data-testid="video-box"
        >
          <video
            poster="/assets/noxway-poster.jpg"
            autoPlay
            muted
            loop
            playsInline
            controls
            preload="metadata"
            className="w-full rounded-xl aspect-video object-cover bg-black"
            data-testid="product-video"
          >
            <source src="/assets/noxway-hero.webm" type="video/webm" />
            <source src="/assets/noxway-hero-web.mp4" type="video/mp4" />
          </video>
        </motion.div>
        <p className="text-center text-sm text-stone-500 mt-5">
          Formula 100 applied to vegetation ahead of an approaching fire front.
        </p>
      </div>
    </section>
  );
}
